<template>
	<div>
		<div class="d-flex">
			<div class="pl-4 pr-2 pt-1 truncate-display-name">{{ printNameDisplay(data) }} </div>
			<div class="v-divider-display mt-1" v-if="data && data.lightstream && data.lightstream.__meta__.total_streamkeys > 0"></div>
			<button
				:class="{'is-loading': isBroadcast, 'disbaled': isBroadcast}"
				v-if="!data.is_live && data && data.lightstream && data.lightstream.__meta__.total_streamkeys > 0"
				type="button"
				class="btn btn-icon pb-2 ml-2 mr-0"
				@click.stop="updateAsset('start', data)" v-tooltip="'Start Broadcast'">
				<i v-show="!isBroadcast" class="material-icons text-success pt-1-5px">play_arrow</i>
			</button>
			<button
				:class="{'is-loading': isBroadcast, 'disbaled': isBroadcast}"
				v-if="data.is_live && data && data.lightstream && data.lightstream.__meta__.total_streamkeys > 0"
				type="button"
				class="btn btn-icon pb-2 ml-2 mr-0"
				@click.stop="updateAsset('stop', data)" v-tooltip="'Stop Broadcast'">
				<i v-show="!isBroadcast" class="material-icons text-danger pt-1-5px">stop</i>
			</button>
		</div>
	</div>
</template>

<script>
import lightstreamsApi from '@/api/lightstream';
import {
	getAxiosErrorMessage,
} from '@/lib/helper';

export default {
	name: 'ButtonBroadcast',
	props: {
		data: {},
	},
	components: {},
	data() {
		return {
			isBroadcast: false,
		};
	},
	sockets: {},
	computed: {},
	methods: {
		updateAsset(status, display) {
			if (status === 'start') {
				this.isBroadcast = true;
				const rundownId = this.data && this.data.rundown && this.data.rundown.id ? this.data.rundown.id : '';
				const baseUrl = process.env.VUE_APP_URL;
				const urlResult = `${baseUrl}/displays/live/${btoa(this.data.slug)}/${btoa(this.data.id)}?${btoa('rundown_id=')}${rundownId}`;
				const params = {
					url: urlResult,
				};
				const callback = () => {
					this.broadcastLive(status, display);
				};
				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Broadcast',
						text: message,
					});
					this.isBroadcast = false;
				};
				// eslint-disable-next-line
				const display_id = this.data && this.data.id ? this.data.id : 0;
				// eslint-disable-next-line
				lightstreamsApi.updateAsset(display_id, params, callback, errorCallback);
			} else {
				this.broadcastLive(status, display);
			}
		},
		broadcastLive(status, display) {
			this.isBroadcast = true;
			const callback = (response) => {
				const item = response.data.display;
				this.$emit('saved', item);
				this.isBroadcast = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Broadcast',
					text: message,
				});
				this.isBroadcast = false;
			};
			const id = display && display.id ? display.id : 0;
			lightstreamsApi.broadcast(status, id, callback, errorCallback);
		},
		printNameDisplay(item) {
			const index = this.printLayerIndex(item);
			const name = item.name;
			const fullName = `${name}  (${index})`;
			return fullName;
		},
		printLayerIndex(item) {
			const layerIndex = item && item.layer_index ? JSON.parse(item.layer_index) : null;
			if (Array.isArray(layerIndex) && layerIndex.length && !layerIndex.includes('0')) {
				return JSON.parse(item.layer_index).toString();
			}
			return 'All';
		},
	},
	watch: {},
	mounted() {},
	created() {},
	destroyed() {},
	beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.page-template {
}
</style>
